import { useState } from "react";
import styles from "./DeleteCardModal.module.scss";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import MainButton from "../../../../shared/button/MainButton";
import { BankCardsPageData } from "../../../../../pages/admin-panels/bank-cards/BankCards";

interface DeleteCardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  pageData: BankCardsPageData;
  translationData: any;
}

const DeleteCardModal = ({
  isOpen,
  onClose,
  onConfirm,
  pageData,
  translationData,
}: DeleteCardModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <GlobalModalComponent isOpen={isOpen} onClose={onClose}>
      <div className={styles.modal_content}>
        <div className={styles.warning_icon}>
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
              stroke="#f05922"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h3 className={styles.modal_title}>
          {translationData?.auth_delete_card_title || "Kartı silmək istəyirsiniz?"}
        </h3>

        <p className={styles.modal_description}>
          {pageData?.confirm_delete ||
            translationData?.auth_delete_card_confirm ||
            "Bu əməliyyatı geri qaytarmaq mümkün olmayacaq. Kartınız sistemdən silinəcək."}
        </p>

        <div className={styles.button_group}>
          <button className={styles.cancel_button} onClick={onClose}>
            {pageData?.cancel_btn || translationData?.auth_cancel || "Ləğv et"}
          </button>
          <MainButton
            text={pageData?.delete_btn || translationData?.auth_delete || "Sil"}
            onClick={handleConfirm}
            isLoading={loading}
            className={styles.delete_button}
          />
        </div>
      </div>
    </GlobalModalComponent>
  );
};

export default DeleteCardModal;
